import React, { Fragment, useState } from 'react'
import InformacionDeSolicitudComponent from './InformacionDeSolicitudComponent';
import InformacionDeEntregaComponent from './InformacionDeEntregaComponent';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
    AgregarInformacionEntrega, ActualizarInformacionEntrega,
    ActualizarFC09, ActualizarFC33, ActualizarFC41, generarReciboHolograma,
    obtenerFolioHolograma, actualizarFolioOficioHolograma
} from '../../../../redux/DuckPanelHologramas/ModuloEntregasDuck';
import { actualizarInventario } from '../../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../../redux/AppDucks';

const DetalleDeEntregaComponent = (props) => {

    const detalleEntrega = useSelector(store => store.ModuloEntregas.detalleEntrega)
    const dispatch = useDispatch()

    let [productos, setProductos] = React.useState([])
    const handdleEditProductosPrev = async (objectProducto) => {
        const filtro = productos.findIndex(anexo => anexo.idproducto === objectProducto.idproducto)
        if (filtro == -1) {
            setProductos(prev => [...prev, objectProducto])
        } else {
            const newProductos = []
            for (const i in productos) {
                const { ...restProducto } = productos[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].categoria = objectProducto.categoria
            newProductos[Number(filtro)].clase = objectProducto.clase
            newProductos[Number(filtro)].estado = objectProducto.estado
            newProductos[Number(filtro)].magueyesSeleccionados = objectProducto.magueyesSeleccionados
            newProductos[Number(filtro)].destino = objectProducto.destino
            setProductos(newProductos)
        }
    }

    const handdleInformacionEntrega = async (object) => {
        let foliosAsignacion = await dispatch(obtenerFolioHolograma(1))
        await dispatch(actualizarLoadingApp_true())
        if (detalleEntrega?.informacionentregahologramas.length == 0) {
            let informacionentregahologramas = {}
            let informacionRecibo = {}
            if (detalleEntrega.formato == 'FC_09') {
                informacionentregahologramas = {
                    idestatusentrega: object?.restante > 0 ? 1 : 2, tiposolicitud: detalleEntrega.formato,
                    idfc09_solicitudcertificado: detalleEntrega.idfc09_solicitudcertificado, idlogin: detalleEntrega?.login?.idlogin
                }
                if (object?.restante == 0) {
                    let data = { idfc09_solicitudcertificado: detalleEntrega.idfc09_solicitudcertificado, isatendida: true }
                    await dispatch(ActualizarFC09(data))
                }
                let marca = ''
                for (const i in detalleEntrega.fc_09_anexoproducto) {
                    let { ...anexoMarca } = detalleEntrega.fc_09_anexoproducto[i]
                    if (detalleEntrega.fc_09_anexoproducto.length - 1 == i) {
                        marca += anexoMarca?.marca?.trim() + ''
                    } else {
                        marca += anexoMarca?.marca.trim() + ', '
                    }
                }
                informacionRecibo = {
                    nombrerazonsocial: detalleEntrega?.nombrecliente, numerosocio: detalleEntrega?.numerocliente,
                    folios: object?.prefijo + '' + object?.folioinicial + ' - ' + object?.prefijo + '' + object?.foliofinal, tiposolicitud: detalleEntrega.formato,
                    idprincipal: detalleEntrega.idfc09_solicitudcertificado, marca: marca,
                    totalpiezas: object?.hologramasentregados, folioOficio: foliosAsignacion?.payload?.folio,
                    solicitudservicios: detalleEntrega?.informacionmodalaceptada != null ? detalleEntrega?.informacionmodalaceptada?.numerosolicitudservicios : ''
                }
                let resta = Number(Number(detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal) - Number(object?.hologramasentregados))
                let dataInventario = {
                    idinventario: detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.idinventario,
                    hologramasmezcal: resta.toString()
                }
                await dispatch(actualizarInventario(dataInventario))
            }
            if (detalleEntrega.formato == 'FC_33') {
                informacionentregahologramas = {
                    idestatusentrega: object?.restante > 0 ? 1 : 2, tiposolicitud: detalleEntrega.formato,
                    idfc33_solicitudenvasadonaciona: detalleEntrega.idfc33_solicitudenvasadonaciona, idlogin: detalleEntrega?.login?.idlogin
                }
                if (object?.restante == 0) {
                    let data = { idfc33_solicitudenvasadonaciona: detalleEntrega.idfc33_solicitudenvasadonaciona, isatendida: true }
                    await dispatch(ActualizarFC33(data))
                }
                let marca = ''
                for (const i in detalleEntrega.fc_33_anexoproducto) {
                    let { ...anexoMarca } = detalleEntrega.fc_33_anexoproducto[i]
                    if (detalleEntrega.fc_33_anexoproducto.length - 1 == i) {
                        marca += anexoMarca?.marca?.trim() + ''
                    } else {
                        marca += anexoMarca?.marca?.trim() + ', '
                    }
                }
                informacionRecibo = {
                    nombrerazonsocial: detalleEntrega?.nombrecliente, numerosocio: detalleEntrega?.numerocliente,
                    folios: object?.prefijo + '' + object?.folioinicial + ' - ' + object?.prefijo + '' + object?.foliofinal, tiposolicitud: detalleEntrega.formato,
                    idprincipal: detalleEntrega.idfc33_solicitudenvasadonaciona, marca: marca,
                    totalpiezas: object?.hologramasentregados, folioOficio: foliosAsignacion?.payload?.folio,
                    solicitudservicios: detalleEntrega?.informacionmodalaceptada != null ? detalleEntrega?.informacionmodalaceptada?.numerosolicitudservicios : ''
                }
                let resta = Number(Number(detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal) - Number(object?.hologramasentregados))
                let dataInventario = {
                    idinventario: detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.idinventario,
                    hologramasmezcal: resta.toString()
                }
                await dispatch(actualizarInventario(dataInventario))
            }
            if (detalleEntrega.formato == 'FC_41') {
                informacionentregahologramas = {
                    idestatusentrega: object?.restante > 0 ? 1 : 2, tiposolicitud: detalleEntrega.formato,
                    idfc41_solicitudparabebidasconm: detalleEntrega.idfc41_solicitudparabebidasconm, idlogin: detalleEntrega?.login?.idlogin
                }
                if (object?.restante == 0) {
                    let data = { idfc41_solicitudparabebidasconm: detalleEntrega.idfc41_solicitudparabebidasconm, isatendida: true }
                    await dispatch(ActualizarFC41(data))
                }
                let marca = ''
                for (const i in detalleEntrega.fc_41_anexoproducto) {
                    let { ...anexoMarca } = detalleEntrega.fc_41_anexoproducto[i]
                    if (detalleEntrega.fc_41_anexoproducto.length - 1 == i) {
                        marca += anexoMarca?.marca?.trim() + ''
                    } else {
                        marca += anexoMarca?.marca?.trim() + ', '
                    }
                }
                informacionRecibo = {
                    nombrerazonsocial: detalleEntrega?.nombrerazonsocial, numerosocio: detalleEntrega?.numerocliente,
                    folios: object?.prefijo + '' + object?.folioinicial + ' - ' + object?.prefijo + '' + object?.foliofinal, tiposolicitud: detalleEntrega.formato,
                    idprincipal: detalleEntrega.idfc41_solicitudparabebidasconm, marca: marca,
                    totalpiezas: object?.hologramasentregados, folioOficio: foliosAsignacion?.payload?.folio,
                    solicitudservicios: detalleEntrega?.informacionmodalaceptada != null ? detalleEntrega?.informacionmodalaceptada?.numerosolicitudservicios : ''
                }
                let resta = Number(Number(detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas) - Number(object?.hologramasentregados))
                let dataInventario = {
                    idinventario: detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.idinventario,
                    hologramasbebidas: resta.toString()
                }
                await dispatch(actualizarInventario(dataInventario))
            }
            let dataInformacion = { informacionentregahologramas, object, productos, informacionRecibo }
            await dispatch(AgregarInformacionEntrega(dataInformacion))

        } else {
            let informacionentregahologramas = {}
            let informacionRecibo = {}
            if (detalleEntrega.formato == 'FC_09') {
                informacionentregahologramas = {
                    idestatusentrega: object?.restante > 0 ? 1 : 2, tiposolicitud: detalleEntrega.formato,
                    idinformacionentrega: detalleEntrega?.informacionentregahologramas?.[0]?.idinformacionentrega
                }
                if (object?.restante == 0) {
                    let data = { idfc09_solicitudcertificado: detalleEntrega.idfc09_solicitudcertificado, isatendida: true }
                    await dispatch(ActualizarFC09(data))
                }
                let marca = ''
                for (const i in detalleEntrega.fc_09_anexoproducto) {
                    let { ...anexoMarca } = detalleEntrega.fc_09_anexoproducto[i]
                    if (detalleEntrega.fc_09_anexoproducto.length - 1 == i) {
                        marca += anexoMarca?.marca?.trim() + ''
                    } else {
                        marca += anexoMarca?.marca?.trim() + ', '
                    }
                }
                informacionRecibo = {
                    nombrerazonsocial: detalleEntrega?.nombrecliente, numerosocio: detalleEntrega?.numerocliente,
                    folios: object?.prefijo + '' + object?.folioinicial + ' - ' + object?.prefijo + '' + object?.foliofinal, tiposolicitud: detalleEntrega.formato,
                    idprincipal: detalleEntrega.idfc09_solicitudcertificado, marca: marca,
                    totalpiezas: object?.hologramasentregados, folioOficio: foliosAsignacion?.payload?.folio,
                    solicitudservicios: detalleEntrega?.informacionmodalaceptada != null ? detalleEntrega?.informacionmodalaceptada?.numerosolicitudservicios : ''
                }
                let resta = Number(Number(detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal) - Number(object?.hologramasentregados))
                let dataInventario = {
                    idinventario: detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.idinventario,
                    hologramasmezcal: resta.toString()
                }
                await dispatch(actualizarInventario(dataInventario))
            }
            if (detalleEntrega.formato == 'FC_33') {
                informacionentregahologramas = {
                    idestatusentrega: object?.restante > 0 ? 1 : 2, tiposolicitud: detalleEntrega.formato,
                    idinformacionentrega: detalleEntrega?.informacionentregahologramas?.[0]?.idinformacionentrega
                }
                if (object?.restante == 0) {
                    let data = { idfc33_solicitudenvasadonaciona: detalleEntrega.idfc33_solicitudenvasadonaciona, isatendida: true }
                    await dispatch(ActualizarFC33(data))
                }
                let marca = ''
                for (const i in detalleEntrega.fc_33_anexoproducto) {
                    let { ...anexoMarca } = detalleEntrega.fc_33_anexoproducto[i]
                    if (detalleEntrega.fc_33_anexoproducto.length - 1 == i) {
                        marca += anexoMarca?.marca?.trim() + ''
                    } else {
                        marca += anexoMarca?.marca?.trim() + ', '
                    }
                }
                informacionRecibo = {
                    nombrerazonsocial: detalleEntrega?.nombrecliente, numerosocio: detalleEntrega?.numerocliente,
                    folios: object?.prefijo + '' + object?.folioinicial + ' - ' + object?.prefijo + '' + object?.foliofinal, tiposolicitud: detalleEntrega.formato,
                    idprincipal: detalleEntrega.idfc33_solicitudenvasadonaciona, marca: marca,
                    totalpiezas: object?.hologramasentregados, folioOficio: foliosAsignacion?.payload?.folio,
                    solicitudservicios: detalleEntrega?.informacionmodalaceptada != null ? detalleEntrega?.informacionmodalaceptada?.numerosolicitudservicios : ''
                }
                let resta = Number(Number(detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal) - Number(object?.hologramasentregados))
                let dataInventario = {
                    idinventario: detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.idinventario,
                    hologramasmezcal: resta.toString()
                }
                await dispatch(actualizarInventario(dataInventario))
            }
            if (detalleEntrega.formato == 'FC_41') {
                informacionentregahologramas = {
                    idestatusentrega: object?.restante > 0 ? 1 : 2, tiposolicitud: detalleEntrega.formato,
                    idinformacionentrega: detalleEntrega?.informacionentregahologramas?.[0]?.idinformacionentrega
                }
                if (object?.restante == 0) {
                    let data = { idfc41_solicitudparabebidasconm: detalleEntrega.idfc41_solicitudparabebidasconm, isatendida: true }
                    await dispatch(ActualizarFC41(data))
                }
                let marca = ''
                for (const i in detalleEntrega.fc_41_anexoproducto) {
                    let { ...anexoMarca } = detalleEntrega.fc_41_anexoproducto[i]
                    if (detalleEntrega.fc_41_anexoproducto.length - 1 == i) {
                        marca += anexoMarca?.marca?.trim() + ''
                    } else {
                        marca += anexoMarca?.marca?.trim() + ', '
                    }
                }
                informacionRecibo = {
                    nombrerazonsocial: detalleEntrega?.nombrerazonsocial, numerosocio: detalleEntrega?.numerocliente,
                    folios: object?.prefijo + '' + object?.folioinicial + ' - ' + object?.prefijo + '' + object?.foliofinal, tiposolicitud: detalleEntrega.formato,
                    idprincipal: detalleEntrega.idfc41_solicitudparabebidasconm, marca: marca,
                    totalpiezas: object?.hologramasentregados, folioOficio: foliosAsignacion?.payload?.folio,
                    solicitudservicios: detalleEntrega?.informacionmodalaceptada != null ? detalleEntrega?.informacionmodalaceptada?.numerosolicitudservicios : ''
                }
                let resta = Number(Number(detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas) - Number(object?.hologramasentregados))
                let dataInventario = {
                    idinventario: detalleEntrega?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.idinventario,
                    hologramasbebidas: resta.toString()
                }
                await dispatch(actualizarInventario(dataInventario))
            }
            let dataInformacion = { informacionentregahologramas, object, productos, informacionRecibo }
            await dispatch(ActualizarInformacionEntrega(dataInformacion))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/PanelEntregasComponent')
        await dispatch(actualizarFolioOficioHolograma({ idoficioholograma: 1, folio: await cambiarFolio(foliosAsignacion.payload.folio) }))
    }
    const cambiarFolio = async (folio) => {
        const nuevoFolio = ('000' + (parseInt(folio, 10) + 1)).slice(-4)
        return nuevoFolio
    }
    React.useEffect(async () => {
        if (detalleEntrega?.informacionentregahologramas?.length > 0) {
            setProductos(detalleEntrega?.informacionentregahologramas?.[0]?.informacionprodutohologramas)
        }
    }, [])

    return (
        <div className='container2 mt-5 row'>
            {detalleEntrega?.fc_09_anexoproducto?.map((anexo, index) => (
                <div key={index} >
                    <InformacionDeSolicitudComponent data={anexo} formato={'FC_09'} api={{ handdleEditProductosPrev, productos }}
                        infoproducto={productos.length > 0 ? productos?.filter(anexoP => anexoP?.idproducto == anexo?.idfc09_anexoproducto) : []} />
                </div>
            ))}
            {detalleEntrega?.fc_33_anexoproducto?.map((anexo, index) => (
                <div key={index}>
                    <InformacionDeSolicitudComponent data={anexo} formato={'FC_33'} api={{ handdleEditProductosPrev, productos }}
                        infoproducto={productos.length > 0 ? productos?.filter(anexoP => anexoP?.idproducto == anexo?.idfc33_anexoproducto) : []} />
                </div>
            ))}
            {detalleEntrega?.fc_41_anexoproducto?.map((anexo, index) => (
                <div key={index} >
                    <InformacionDeSolicitudComponent data={anexo} formato={'FC_41'} api={{ handdleEditProductosPrev, productos }}
                        infoproducto={productos.length > 0 ? productos?.filter(anexoP => anexoP?.idproducto == anexo?.idfc41_anexoproducto) : []} />
                </div>
            ))}
            {detalleEntrega?.formato == 'FC_09' &&
                <div>
                    <InformacionDeEntregaComponent productos={detalleEntrega.fc_09_anexoproducto} api={{ handdleInformacionEntrega }} infoProductos={productos} />
                </div>
            }
            {detalleEntrega?.formato == 'FC_33' &&
                <div>
                    <InformacionDeEntregaComponent productos={detalleEntrega.fc_33_anexoproducto} api={{ handdleInformacionEntrega }} infoProductos={productos} />
                </div>
            }
            {detalleEntrega?.formato == 'FC_41' &&
                <div>
                    <InformacionDeEntregaComponent productos={detalleEntrega.fc_41_anexoproducto} api={{ handdleInformacionEntrega }} infoProductos={productos} />
                </div>
            }

        </div>
    );

};

export default withRouter(DetalleDeEntregaComponent)